var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtBsc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5403_22742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6973 0H0.697266V26.1528H32.6973V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5403_22742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7737 25.8339C20.8222 25.8339 26.5312 20.125 26.5312 13.0764C26.5312 6.02794 20.8222 0.31897 13.7737 0.31897C6.7252 0.31897 1.01624 6.02794 1.01624 13.0764C1.01624 20.125 6.7252 25.8339 13.7737 25.8339Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3365 13.9588C15.2515 13.9588 14.7943 13.9907 13.7844 13.9907C12.9764 13.9907 12.4129 13.9694 12.2109 13.9588C9.10662 13.8206 6.79965 13.2784 6.79965 12.6405C6.79965 12.0026 9.11725 11.4604 12.2109 11.3116V13.4166C12.4129 13.4272 12.9977 13.4697 13.795 13.4697C14.7624 13.4697 15.2408 13.4272 15.3259 13.4272V11.3222C18.4196 11.4604 20.7266 12.0026 20.7266 12.6405C20.7372 13.2784 18.4302 13.8206 15.3365 13.9588ZM15.3365 11.099V9.20661H19.6528V6.33618H7.90529V9.21724H12.2216V11.099C8.71327 11.2584 6.07672 11.9601 6.07672 12.7893C6.07672 13.6186 8.71327 14.3202 12.2216 14.4797V20.5182H15.3365V14.4691C18.8342 14.3096 21.4707 13.6186 21.4707 12.7787C21.4707 11.9388 18.8448 11.2584 15.3365 11.099Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2554 20.5182C29.3697 20.5182 32.6973 17.1907 32.6973 13.0764C32.6973 8.9621 29.3697 5.63452 25.2554 5.63452C21.1411 5.63452 17.8135 8.9621 17.8135 13.0764C17.8135 17.1907 21.1411 20.5182 25.2554 20.5182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2554 20.1993C29.189 20.1993 32.3784 17.01 32.3784 13.0764C32.3784 9.14286 29.189 5.95349 25.2554 5.95349C21.3219 5.95349 18.1325 9.14286 18.1325 13.0764C18.1325 17.01 21.3219 20.1993 25.2554 20.1993Z",
    fill: "#F3BA2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5225 12.3641L25.2554 10.6313L26.9883 12.3641L27.9982 11.3542L25.2554 8.62195L22.5232 11.3542L23.5225 12.3641ZM20.8009 13.0764L21.8109 12.0665L22.8208 13.0764L21.8109 14.0864L20.8009 13.0764ZM23.5225 13.7887L25.2554 15.5216L26.9883 13.7887L27.9982 14.7987L25.2554 17.5309L22.5232 14.7987L23.5225 13.7887ZM27.6899 13.0764L28.6999 12.0665L29.7099 13.0764L28.6999 14.0864L27.6899 13.0764ZM26.276 13.0764L25.2554 14.097L24.2348 13.0764L24.4155 12.8957L24.5006 12.8107L25.2554 12.0558L26.276 13.0764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtBsc);
export default __webpack_public_path__ + "static/media/usdt_bsc.92afe70bc0c1a6be822bc4f42e5d5d9d.svg";
export { ForwardRef as ReactComponent };